import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import type { CompanyApi } from '@/modules/companies/types';

import { companiesQueryKeys } from './queryKeys';

export const useCompanyQuery = (
  id: string,
  options?: Omit<
    UseQueryOptions<CompanyApi | undefined, unknown>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: companiesQueryKeys.detail(id),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.company, {
        params: { path: { id } },
      });
      return data;
    },
    ...options,
  });
};
